import { WifiOff, RefreshCw } from 'lucide-react';
import { useServerStatus } from '../hooks/useServerStatus';

export default function ServerStatusBanner() {
  const { offline, checking, retry } = useServerStatus();

  if (!offline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-red-500 text-white text-[13px] font-medium px-4 py-2 flex items-center justify-between shadow-lg">
      <div className="flex items-center gap-2">
        <WifiOff className="w-4 h-4 shrink-0" strokeWidth={2} />
        <span>Нет соединения с сервером</span>
      </div>
      <button
        onClick={retry}
        disabled={checking}
        className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 active:bg-white/40 px-2.5 py-1 rounded-lg transition-colors disabled:opacity-60"
      >
        <RefreshCw className={`w-3.5 h-3.5 ${checking ? 'animate-spin' : ''}`} strokeWidth={2.5} />
        <span>{checking ? 'Проверка...' : 'Повторить'}</span>
      </button>
    </div>
  );
}
